import type { AuthUser } from '@stayon/auth-core';
import type { PropertyLifecycleStatus } from '@/shared/api';
import { canManage, isWorkspaceAdmin } from '@/shared/auth';

/**
 * Nimmt bewusst den AuthUser und nicht rohe Rollen-Strings: eine String-Liste hat den
 * Rollen-Umbau in Sprint 33 stillschweigend ueberlebt (`roles.includes('Admin')` war danach
 * immer false), weil der Compiler Literale nicht prueft. Ueber die Helfer aus shared/auth
 * bricht so etwas beim naechsten Mal am Typ.
 */
export function apartmentLifecycleUi(user: AuthUser | null, status: PropertyLifecycleStatus) {
  const readOnly = status === 'Archived';
  return {
    canEdit: canManage(user) && !readOnly,
    canArchive: isWorkspaceAdmin(user) && !readOnly,
    readOnly,
    /**
     * Pausieren und Fortsetzen sind Verwalter-Aktionen (so sagt es der Endpunkt
     * `WorkspaceAdminAndStaff`) und nur aus dem laufenden Betrieb heraus sinnvoll: ein Entwurf ist
     * noch nicht veroeffentlicht, ein archiviertes Apartment ist raus.
     */
    lifecycleAction:
      canManage(user) && status === 'Active'
        ? ('pause' as const)
        : canManage(user) && status === 'Paused'
          ? ('resume' as const)
          : null,
  };
}
